import { Image, View } from "react-native";
import { IStepComponentProps } from "@shared/components/form/types";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { Head } from "@shared/components/head";
import { Text } from "@shared/components/text";
import { VideoViewer } from "@shared/components/VideoViewer";
import { useAuth } from "app/auth/hooks/useAuth";
import { ActivityName } from "app/_modules/core/types";

export const TutorialStep = ({ translations, context }: IStepComponentProps<undefined, { activityName: ActivityName }>) => {
  const { meData } = useAuth();
  const { t } = dynamicTranslations();

  const activityName = context?.activityName!
  const vitalParameterData = meData?.current_pathway.vital_parameters.find((vitalParameter) => vitalParameter.vital_parameter.name === activityName)

  const tutorialMediaUrl = vitalParameterData?.device_vital_parameter.tutorial_media_url;
  const tutorialSteps = vitalParameterData?.device_vital_parameter.tutorial_steps;

  return (
    <View className="flex-col gap-4">
      <Head type="h2">{t(translations?.title || "")}</Head>

      {tutorialSteps && (
        <View>
          <Text className="text-base leading-normal">
            {tutorialSteps}
          </Text>
        </View>
      )}

      {tutorialMediaUrl && (
        <View className="w-full rounded-lg overflow-hidden" style={{ height: 500 }}>
          {tutorialMediaUrl.includes('.png') ? (
            <Image
              source={{ uri: tutorialMediaUrl }}
              style={{ width: '100%', height: 400, marginTop: 50, backgroundColor: "#fff" }}
              resizeMode="contain"
            />
          ) : (
            <VideoViewer
              videoUrl={tutorialMediaUrl}
              style={{ height: 256 }}
              resizeMode="contain"
              controls={true}
              paused={false}
              repeat={false}
            />
          )}
        </View>
      )}
    </View>
  );
};